var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2565 17.9143C35.5717 17.9143 34.0794 19.9044 33.7666 22.062H42.795C42.5497 20.0043 41.0956 17.9216 38.258 17.9216L38.2565 17.9143ZM33.8341 25.0084C34.2938 27.2717 36.168 28.8624 38.7926 28.8624C40.207 28.8624 42.2574 28.3351 43.4574 27.0719L45.7604 29.7201C43.6806 31.8924 40.5669 32.5122 38.4401 32.5122C33.2687 32.5122 29.2384 28.7772 29.2384 23.4838C29.2384 18.5268 32.947 14.4422 38.1875 14.4422C43.2518 14.4422 47 18.3197 47 23.4544V24.9525H33.8341V25.0084ZM21.128 32.5049V21.3585C21.128 19.455 20.2776 18.352 18.5033 18.352C16.9127 18.352 15.8581 19.4991 15.1443 20.326V32.5416H10.5398V21.3805C10.5398 19.4668 9.72901 18.3828 7.96063 18.3828C6.36998 18.3828 5.26841 19.5299 4.59573 20.3568V32.5724H-0.00292969V14.7021H4.60307V16.9508C5.38298 16.0475 7.14841 14.4877 9.90379 14.4877C12.3522 14.4877 14.0104 15.5144 14.7521 17.6015C15.7847 16.1107 17.6896 14.4877 20.4509 14.4877C23.7864 14.4877 25.7222 16.4617 25.7222 20.2863V32.5122H21.1162L21.1236 32.496L21.128 32.5049Z",
    fill: "#05386B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMe);
export default __webpack_public_path__ + "static/media/me.d9dba428c81517de199d3125c1a704be.svg";
export { ForwardRef as ReactComponent };